











































import { Component, Vue } from "vue-property-decorator";
import { Checkbox, CheckboxGroup, Button } from "vant";
import NetErrorPage from "@/components/NetErrorPage.vue";

@Component({
  name: "ServiceOpening",
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    NetErrorPage: NetErrorPage
  }
})
export default class ServiceOpening extends Vue {
  serverList = [];
  serverIdListchecked: any = [];
  showPage = false;

  isLoading = true;
  requestFail = true;

  activated() {
    /**如果首次请求失败后再次进入重新请求 */
    if (this.requestFail) {
      this.getServerList();
    }
  }
  getServerList() {
    this.isLoading = true;
    (this as any).$apis
      .getServerList({open_method:this.$route.query.open_method?this.$route.query.open_method:1})
      .then(res => {
        this.requestFail = false;
        
        this.showPage = true;
        this.serverList = this.setServerListInitCheckStatus(res);
      })
      .catch(e => {
        this.requestFail = true;
        
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  setServerListInitCheckStatus(list) {
    list.forEach(item => {
      if (item.level !== 1) {
        item.isChecked = true;
      }
      if (item.children) {
        this.setServerListInitCheckStatus(item.children);
      }
    });
    return list;
  }

  handleSaveServerInfo() {
    this.serverIdListchecked = [];
    this.setSeverIdListChecked(this.serverList);
    const isVerify = this.serverIdListchecked.some(item => {
      return item.id == 3;
    });
    // if (!isVerify) {
    //   return this.$toast(
    //     this.$t("open_account.service_opening.verify_fail_text")
    //   );
    // }
    const idList = this.serverIdListchecked.map(item => {
      return item.id;
    });
    (this as any).$apis
      .saveAccountServer({
        server_id: idList.join(",") 
      })
      .then(() => {

		(this as any).$apis
		  .saveCompanySave().then(() =>{
			  const userInfo =  (this as any).$localstorage.get("userInfo") || {};
			  let path = '/m-result';
			  // if(userInfo.is_model_hl) {
			  //   path = '/electronic-sign'
			  // } else {
			  //   path = "/trade-password-setting"
			  // }
			  this.$router.push({
			    path,
			    query: this.$route.query
			  });
		  })


      })
      .catch(e => {
        
      });
  }

  setSeverIdListChecked(list) {
    list.forEach(item => {
      
      if (item.level !== 1 && item.isChecked) {
        this.serverIdListchecked.push({
          id: item.id,
          name: item.name
        });
        
      }
      if (item.children) {
        this.setSeverIdListChecked(item.children);
      }
    });
  }
}
